import { Component } from '@angular/core';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  faFacebookF = faFacebookF;
  faX = faXTwitter;
  faLinkedinIn = faLinkedinIn;
  faInstagram = faInstagram;

  year = new Date().getFullYear();
}
